import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@material-ui/core";
import { Backdrop } from "@material-ui/core";

const ConfirmationModal = ({ open, close,message, submit, loading }) => {
  return (
    <Dialog open={open} onClose={close} fullWidth={true}>
      <DialogContent>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          p={2}
          mt={1}
        >
          <Typography variant="h4" style={{ width: "80%" }}>
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          m={1}
        >
          <Button variant="outlined" color="secondary" onClick={close}>
            NO
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={submit}
            style={{ marginLeft: "20px" }}
          >
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
